import { Row } from '@tanstack/react-table';
import { UpstreamEvent } from 'client';
import { Link } from 'react-router';

import LongText from 'components/LongText';

type Props = {
  row: Row<UpstreamEvent>;
};

export function Title({ row }: Props) {
  const title = row.original.title;
  const eventId = row.original.event_id;

  return (
    <Link to={`/disruptions/events/${eventId}`} className="min-w-0 font-medium text-indigo-600">
      <LongText text={title} />
    </Link>
  );
}
